export const EyeOffIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M14.5215 10.3789C14.8228 10.8467 15 11.4022 15 12C15 13.6569 13.6569 15 12 15C11.0835 15 10.2641 14.5881 9.71387 13.9404L10.5205 13.3428C10.8864 13.7457 11.4129 14 12 14C13.1046 14 14 13.1046 14 12C14 11.6255 13.895 11.2762 13.7158 10.9766L14.5215 10.3789ZM12 9C12.5045 9 12.9792 9.12572 13.3965 9.3457L12.4453 10.0508C12.302 10.0182 12.1531 10 12 10C10.9434 10 10.08 10.8195 10.0068 11.8574L9.05273 12.5635C9.01805 12.381 9 12.1926 9 12C9 10.3431 10.3431 9 12 9Z'
        fill='currentColor'
      />
      <path d='M19 7L5.5 17' stroke='currentColor' strokeLinecap='round' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15.4882 7.79824C14.4342 7.28688 13.2511 7.00007 12.001 7C8.6436 7 5.76881 9.06817 4.58203 12C4.97914 12.981 5.56525 13.8654 6.2952 14.6079L7.1081 14.0057C6.51971 13.4305 6.03223 12.7522 5.6748 12C6.79908 9.63379 9.21021 8 12.001 8C12.905 8.00006 13.7691 8.17161 14.5624 8.48398L15.4882 7.79824ZM8.33418 14.9637C9.40081 15.621 10.6569 16 12.001 16C14.7914 15.9998 17.2009 14.3659 18.3252 12C17.8036 10.9024 17.0054 9.96236 16.0209 9.26988L16.8625 8.64647C17.9886 9.50955 18.8787 10.6653 19.4189 12C18.2322 14.9317 15.3581 16.9998 12.001 17C10.3219 17 8.76361 16.4827 7.47673 15.5989L8.33418 14.9637Z'
        fill='currentColor'
      />
    </svg>
  )
}
